import type { OpenAPIV3_1 } from 'openapi-types';
import type { TableSnapshotArgumentMode } from '../table';
import type { OasOperationTable } from './OasOperationTable';

const getRequestSchema = (
  oasOperationTable: OasOperationTable,
): OpenAPIV3_1.SchemaObject | undefined =>
  (oasOperationTable?.requestBody as OpenAPIV3_1.RequestBodyObject)?.content?.[
    'application/json'
  ]?.schema as OpenAPIV3_1.SchemaObject;
export const existsFieldInOASRequestBody = (
  oasOperationTable: OasOperationTable,
  field: string,
): boolean => {
  const schema = getRequestSchema(oasOperationTable);
  return schema?.properties
    ? Object.keys(schema.properties).includes(field)
    : false;
};
export const getTableSnapshotMode = (
  oasOperationTable: OasOperationTable,
): TableSnapshotArgumentMode => {
  if (!existsFieldInOASRequestBody(oasOperationTable, 'snapshot')) {
    return 'forbidden';
  }

  const requiredFields = getRequestSchema(oasOperationTable)?.required;
  if (requiredFields?.includes('snapshot')) {
    return 'required';
  }

  return 'optional';
};
